import { CALL_API, SESSION_COOKIE_NAME } from './../constants'
import { makeCall, objectToFormData } from './../helpers'
import { PURGE } from 'redux-persist'
import { CHECK_CONNECTIVITY } from './../components/connectivity'
import { debounce } from 'lodash-es'
import rootRoutes from "src/routes.js"


const DEBOUNCE_DELAY = 200

const debouncedExecute = debounce((fn) => fn(), DEBOUNCE_DELAY)

function getCookie(name) {
  console.log('All cookies:', document.cookie);
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) {
    const cookieValue = parts.pop().split(';').shift();
    console.log(`Found ${name}:`, cookieValue);
    return cookieValue;
  }
  console.log(`Cookie ${name} not found`);
  return null
}

const api = store => next => async action => {
  if (!action || !action.type || action.type !== CALL_API) {
    return next(action)
  }

  const { actions, endpoint, method, auth, params = {}, isFormData = false, returnResponse = false, extra = {}, headers = {} } = action.meta
  const { token, headerTokenType, audience } = store.getState().common.auth || {}
  let payload = action.payload

  const dispatch = (type, payload) => next({ type, payload })
  if (actions.init) {
    dispatch(actions.init, params)
  }

  // check for authorization  
  if (auth) {
    let tokenType = headerTokenType ? headerTokenType : 'Bearer';
    headers.Authorization = `${tokenType} ${token}`;
    headers.audience = audience;
  }

  // check for form data
  if (isFormData) {
    headers['Content-Type'] = 'multipart/form-data'
    let jsonString;
    payload = objectToFormData(action.payload)
    if (action.payload.vaccines_set) {
      jsonString = JSON.stringify(action.payload.vaccines_set);
      payload.append('vaccines_set', jsonString);
    }
    if (action.payload.vaccines_passe_set) {
      jsonString = JSON.stringify(action.payload.vaccines_passe_set);
      payload.append('vaccines_set', jsonString);
    }
  }

  
  // Use the same token in X-CSRFToken header
  const csrfToken = getCookie('csrftoken');

  if (csrfToken) {
    headers['X-CSRFToken'] = csrfToken
  }
  headers['X-Session-ID'] = SESSION_COOKIE_NAME

  const executeCall = () => {
    makeCall(method, endpoint, payload, headers, params, extra)
      .then(resp => {
        dispatch(actions.success, returnResponse ? resp : resp.data)
      })
      .catch(err => {
        if (err.message === 'Network Error') {
          next({ type: CHECK_CONNECTIVITY })
        } else if (err?.response?.status === 401 && auth) {
          next({ type: PURGE, result: () => null })
          // window.location.href = rootRoutes.logout.path
        } else if (err?.response?.status === 403) {
          dispatch(actions.fail, { ...err.response, status: 403 })
        } else {
          dispatch(actions.fail, err.response || {})
        }
      })
  }

  executeCall()
}

export default api
